import React from "react";

interface StartPageProps {
  childName: string;
  gender: string;
  photoUrl?: string;
  onGetStarted: () => void;
}

/**
 * Initial landing page that introduces the card creation experience
 * - Shows the sponsored child's photo and personalized welcome text
 * - Contains the primary call-to-action to begin the process
 */
const StartPage: React.FC<StartPageProps> = ({ childName, gender, photoUrl, onGetStarted }) => {
  const subjectPronoun = gender === "Female" ? "She" : "He";

  return (
    <div className="start-page">
      {photoUrl && (
        <div className="photo-container">
          <img src={photoUrl} alt={`Photo of ${childName}`} className="child-photo" />
        </div>
      )}
      <div className="sak-engagement-flow__wrapper">
        <div className="sak-engagement-flow__header">
          <h1>Make a card for {childName}</h1>
        </div>

        <div className="sak-engagement-flow__body">
          <p>
            This is the start of a wonderful adventure. Create a special card for {childName} in two
            simple steps — add a photo and a quick message to introduce yourself. {subjectPronoun}{" "}
            will be excited to hear from you!
          </p>
        </div>

        <div className="sak-engagement-flow__controls">
          <button onClick={onGetStarted} className="btn btn-primary">
            Get started
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartPage;
